package com.vamvisions.main.components

import androidx.compose.runtime.Composable
import com.vamvisions.main.core.presentation.navigation.Route
import com.vamvisions.main.i18n.LocalStrings
import com.vamvisions.main.theme.AppStyleSheet
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLElement

/**
 * The glass card that ends the Home, Portfolio and Projects pages: a heading, an invitation and the primary
 * "Get in touch" link to the Contact page. [title] and [text] default to "Let's connect". Side by side on wide screens,
 * centred and stacked on phones. [attrs] adds to the card, and [button] wraps the link, for example to animate them.
 */
@Composable
fun ConnectCard(
    onNavigate: (Route) -> Unit,
    title: String = LocalStrings.current.connectTitle,
    text: String = LocalStrings.current.connectText,
    attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null,
    button: (AttrsScope<HTMLElement>.() -> Unit)? = null,
) {
    val strings = LocalStrings.current
    val titleId = "connect-title"
    Card(glass = true, attrs = {
        classes(AppStyleSheet.connectCard)
        attr("aria-labelledby", titleId)
        attrs?.invoke(this)
    }) {
        Div(attrs = { classes(AppStyleSheet.connectText) }) {
            H2(attrs = {
                id(titleId)
                classes(AppStyleSheet.connectTitle)
            }) { Text(title) }
            P(attrs = { classes(AppStyleSheet.connectBody) }) { Text(text) }
        }
        Div(attrs = {
            classes(AppStyleSheet.connectButton)
            button?.invoke(this)
        }) {
            LinkButton(strings.connectLink, Route.Contact, onNavigate, primary = true)
        }
    }
}
